import { getDefaultCardSelection, isProductHasVariants } from '../components/ProductCardQuantity';

export const getCartItemKey = (item) => {
    if (!item) return '';
    if (item.cartKey) return String(item.cartKey);
    if (item.weightLabel) return `${item.id}__${item.weightLabel}`;
    return String(item.id);
};

export const buildCartProductFromSelection = (product, basePrice, selection) => {
    const hasVariants = isProductHasVariants(product);
    const sel = selection || getDefaultCardSelection(hasVariants);
    const quantity = Math.max(1, sel.quantity || 1);

    if (hasVariants) {
        if (!sel.weightValue || !sel.weightLabel) {
            return { error: 'Choisissez un poids (250g, 500g ou 1kg)' };
        }

        const factor = Number(sel.weightValue);
        const unitPrice = Number(basePrice) * factor;

        return {
            product: {
                ...product,
                price: unitPrice,
                price_casa: unitPrice,
                weightLabel: sel.weightLabel,
                weightValue: factor,
                unit: sel.weightLabel,
                weight: sel.weightLabel,
                cartKey: `${product.id}__${sel.weightLabel}`,
            },
            quantity: 1,
        };
    }

    return {
        product: {
            ...product,
            price: Number(basePrice),
            price_casa: Number(basePrice),
            cartKey: String(product.id),
        },
        quantity,
    };
};
